/* Amada welcome pop-up v2, vanilla JS, no dependencies.
   Usage: AmadaPopup.init(document.querySelector('[data-amp]'), { autoOpen: true })
   Options (all optional):
     autoOpen      true    open by itself using the triggers below
     delayMs       10000   open after N ms on the page
     scrollRatio   0.4     or after scrolling this share of the page
     minDelayMs    3000    never before this, even if the scroll rule is met (never on entry)
     exitIntent    true    or when the cursor leaves through the top (desktop)
     waitFor       cookie banner selectors; while one is visible the pop-up waits
     suppressDays  7       days to stay quiet after a close
     klaviyo       { companyId, listId }  sends the email to a Klaviyo list (client API)
     onSubmit      async (email) => {}   custom handler; throw to show the network error
*/
(function (global) {
  'use strict';

  var STORE_KEY = 'amada_popup_v2';
  var EMAIL_RE = /^[^\s@]+@[^\s@.]+(\.[^\s@.]+)*\.[A-Za-z]{2,}$/;
  var FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])';

  function readStore() {
    try { return JSON.parse(localStorage.getItem(STORE_KEY)) || {}; } catch (e) { return {}; }
  }
  function writeStore(patch) {
    try {
      var s = readStore();
      for (var k in patch) s[k] = patch[k];
      localStorage.setItem(STORE_KEY, JSON.stringify(s));
    } catch (e) { /* private mode: ignore */ }
  }

  /* metricas: eventos no GA4 (popup_view, popup_signup, popup_close) para medir a taxa de conversao */
  function track(name, extra) {
    var params = { popup_id: 'welcome_15' };
    for (var k in extra || {}) params[k] = extra[k];
    try { if (typeof global.gtag === 'function') global.gtag('event', name, params); } catch (e) {}
    try { if (global.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish('amada_' + name, params); } catch (e) {}
  }

  function sendToKlaviyo(cfg, email) {
    return fetch('https://a.klaviyo.com/client/subscriptions?company_id=' + encodeURIComponent(cfg.companyId), {
      method: 'POST',
      headers: { 'Content-Type': 'application/vnd.api+json', revision: '2024-10-15' },
      body: JSON.stringify({
        data: {
          type: 'subscription',
          attributes: {
            custom_source: 'Amada welcome pop-up',
            profile: { data: { type: 'profile', attributes: { email: email } } }
          },
          relationships: { list: { data: { type: 'list', id: cfg.listId } } }
        }
      })
    }).then(function (r) { if (!r.ok) throw new Error('klaviyo ' + r.status); });
  }

  function init(root, opts) {
    if (!root) return null;
    opts = opts || {};
    var o = {
      autoOpen: opts.autoOpen !== false,
      delayMs: opts.delayMs == null ? 10000 : opts.delayMs,
      minDelayMs: opts.minDelayMs == null ? 3000 : opts.minDelayMs,
      waitFor: opts.waitFor || '#shopify-pc__banner, .shopify-pc__banner__dialog, #onetrust-banner-sdk, .cc-window, [data-cookie-banner]',
      scrollRatio: opts.scrollRatio == null ? 0.4 : opts.scrollRatio,
      exitIntent: opts.exitIntent !== false,
      suppressDays: opts.suppressDays == null ? 7 : opts.suppressDays,
      klaviyo: opts.klaviyo || null,
      onSubmit: opts.onSubmit || null
    };

    var dialog = root.querySelector('.amp__dialog');
    var form = root.querySelector('[data-amp-form]');
    var input = form.querySelector('input[type="email"]');
    var error = root.querySelector('.amp__error');
    var submit = form.querySelector('button[type="submit"]');
    var step1 = root.querySelector('[data-amp-step="1"]');
    var step2 = root.querySelector('[data-amp-step="2"]');
    var doneTitle = root.querySelector('[data-amp-done-title]');
    var copyBtn = root.querySelector('[data-amp-copy]');
    var copied = root.querySelector('[data-amp-copied]');
    var code = root.querySelector('[data-amp-code]');
    var teaser = root.nextElementSibling && root.nextElementSibling.matches('[data-amp-teaser]')
      ? root.nextElementSibling : document.querySelector('[data-amp-teaser]');

    /* desempenho: imagens do pop-up nao carregam na entrada da pagina; entram pouco antes de abrir */
    var warmed = false;
    function warm() {
      if (warmed) return; warmed = true;
      Array.prototype.forEach.call(root.querySelectorAll('img[data-amp-src]'), function (im) {
        im.src = im.getAttribute('data-amp-src'); im.removeAttribute('data-amp-src');
      });
    }

    var lastFocus = null;
    var isOpen = false;
    var closeTimer = null;

    /* virtual keyboard: keep the sheet above it on phones */
    var vv = global.visualViewport;
    function syncViewport() {
      if (!vv) return;
      var kb = Math.max(0, global.innerHeight - vv.height - vv.offsetTop);
      root.style.setProperty('--amp-kb', kb + 'px');
      root.style.setProperty('--amp-vvh', vv.height + 'px');
    }
    if (vv) { vv.addEventListener('resize', syncViewport); vv.addEventListener('scroll', syncViewport); }

    function focusables() {
      return Array.prototype.filter.call(dialog.querySelectorAll(FOCUSABLE), function (el) {
        return !el.closest('[hidden]') && el.getClientRects().length > 0;
      });
    }

    function onKey(e) {
      if (!isOpen) return;
      if (e.key === 'Escape') { e.preventDefault(); close('esc'); return; }
      if (e.key !== 'Tab') return;
      var f = focusables();
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && (document.activeElement === first || !dialog.contains(document.activeElement))) {
        e.preventDefault(); last.focus();
      } else if (!e.shiftKey && (document.activeElement === last || !dialog.contains(document.activeElement))) {
        e.preventDefault(); first.focus();
      }
    }

    function open(opt) {
      opt = opt || {};
      if (isOpen) return;
      warm();
      track('popup_view', { trigger: opt.trigger || 'auto' });
      clearTimeout(closeTimer);
      isOpen = true;
      lastFocus = document.activeElement;
      if (teaser) teaser.hidden = true;
      root.hidden = false;
      syncViewport();
      document.documentElement.style.overflow = 'hidden';
      document.addEventListener('keydown', onKey, true);
      // next frame so the entrance transition runs
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          root.classList.add('is-open');
          if (opt.focus !== false) {
            var target = step2.hidden ? input : doneTitle;
            // on touch screens do not pop the keyboard on entry, focus the dialog instead
            var coarse = global.matchMedia && global.matchMedia('(pointer: coarse)').matches;
            if (coarse && target === input) { dialog.setAttribute('tabindex', '-1'); dialog.focus({ preventScroll: true }); }
            else target.focus({ preventScroll: true });
          }
        });
      });
    }

    function close(reason) {
      if (!isOpen) return;
      isOpen = false;
      root.classList.remove('is-open');
      document.removeEventListener('keydown', onKey, true);
      document.documentElement.style.overflow = '';
      var subscribed = !step2.hidden;
      if (!subscribed) track('popup_close', { reason: reason || 'dismiss' });
      writeStore(subscribed ? { subscribed: true } : { closedAt: Date.now() });
      var reduce = global.matchMedia && global.matchMedia('(prefers-reduced-motion: reduce)').matches;
      closeTimer = setTimeout(function () {
        root.hidden = true;
        if (!subscribed && teaser) showTeaser();
        if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
      }, reduce ? 200 : 420);
    }

    function showTeaser() {
      if (!teaser || readStore().teaserHidden) return;
      teaser.hidden = false;
    }

    function showDone() {
      step1.hidden = true;
      step2.hidden = false;
      root.classList.add('is-done');
      if (isOpen) doneTitle.focus({ preventScroll: true });
    }

    function setError(msg) {
      error.textContent = msg || '';
      if (msg) input.setAttribute('aria-invalid', 'true');
      else input.removeAttribute('aria-invalid');
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var email = input.value.trim();
      if (!email) { setError('Please enter your email so we can send your code.'); input.focus(); return; }
      if (!EMAIL_RE.test(email)) { setError('That email does not look quite right. Please check it and try again.'); input.focus(); return; }
      setError('');
      submit.setAttribute('aria-busy', 'true');
      submit.disabled = true;
      var label = submit.textContent;
      submit.textContent = 'Sending your code';
      var job = o.onSubmit ? Promise.resolve(o.onSubmit(email))
        : o.klaviyo ? sendToKlaviyo(o.klaviyo, email)
        : Promise.resolve();
      job.then(function () {
        writeStore({ subscribed: true });
        track('popup_signup');
        showDone();
      }).catch(function () {
        setError('Something went wrong on our side. Please try again in a moment.');
      }).then(function () {
        submit.removeAttribute('aria-busy');
        submit.disabled = false;
        submit.textContent = label;
      });
    });
    input.addEventListener('input', function () { if (input.hasAttribute('aria-invalid')) setError(''); });
    input.addEventListener('focus', function () {
      setTimeout(function () { input.scrollIntoView({ block: 'nearest' }); }, 320);
    });

    if (copyBtn && code) copyBtn.addEventListener('click', function () {
      var text = code.textContent.trim();
      function done() {
        copyBtn.textContent = 'Copied';
        copyBtn.classList.add('is-copied');
        copied.textContent = 'Code copied. Paste it at checkout.';
        setTimeout(function () {
          copyBtn.textContent = 'Copy';
          copyBtn.classList.remove('is-copied');
          copied.textContent = '';
        }, 2400);
      }
      if (navigator.clipboard && global.isSecureContext) {
        navigator.clipboard.writeText(text).then(done, fallback);
      } else fallback();
      function fallback() {
        var r = document.createRange(); r.selectNodeContents(code);
        var s = global.getSelection(); s.removeAllRanges(); s.addRange(r);
        try { document.execCommand('copy'); } catch (e) { /* selection stays for manual copy */ }
        done();
      }
    });

    root.addEventListener('click', function (e) {
      if (e.target.closest('[data-amp-close]')) close('dismiss');
    });
    if (teaser) {
      teaser.querySelector('[data-amp-reopen]').addEventListener('click', function () { open({ trigger: 'teaser' }); });
      teaser.querySelector('[data-amp-teaser-dismiss]').addEventListener('click', function () {
        teaser.hidden = true; writeStore({ teaserHidden: true });
      });
    }

    /* triggers */
    function shouldAutoOpen() {
      var s = readStore();
      if (s.subscribed) return false;
      if (s.closedAt && Date.now() - s.closedAt < o.suppressDays * 864e5) { showTeaser(); return false; }
      return true;
    }
    if (o.autoOpen && shouldAutoOpen()) {
      var fired = false;
      var bornAt = Date.now();
      var bannerUp = function () {
        return Array.prototype.some.call(document.querySelectorAll(o.waitFor), function (el) {
          var r = el.getBoundingClientRect();
          return r.width > 0 && r.height > 0 && getComputedStyle(el).visibility !== 'hidden';
        });
      };
      var fire = function () {
        if (fired) return;
        if (Date.now() - bornAt < o.minDelayMs) return;
        if (bannerUp()) { setTimeout(fire, 1500); return; }
        fired = true;
        clearTimeout(t); global.removeEventListener('scroll', onScroll); document.removeEventListener('mouseout', onOut);
        open();
      };
      var t = setTimeout(fire, o.delayMs);
      setTimeout(warm, Math.max(0, o.delayMs - 6000));
      var onScroll = function () {
        var max = document.documentElement.scrollHeight - global.innerHeight;
        if (max > 0 && global.scrollY / max >= o.scrollRatio) fire();
      };
      var onOut = function (e) { if (!e.relatedTarget && e.clientY <= 0) fire(); };
      global.addEventListener('scroll', onScroll, { passive: true });
      if (o.exitIntent && global.matchMedia('(pointer: fine)').matches) document.addEventListener('mouseout', onOut);
    }

    return {
      open: open,
      close: close,
      showDone: function () { showDone(); },
      showTeaser: function () { if (isOpen) { isOpen = false; root.classList.remove('is-open'); root.hidden = true; document.documentElement.style.overflow = ''; document.removeEventListener('keydown', onKey, true); } teaser.hidden = false; },
      reset: function () {
        step1.hidden = false; step2.hidden = true; root.classList.remove('is-done');
        form.reset(); setError('');
      }
    };
  }

  global.AmadaPopup = { init: init };
})(window);
